// The one header every screen with a schedule on it carries: the day in display
// type, a badge saying what this screen is doing to that day, and a single line
// under it. Nothing else sits between the top bar and the chart.

import type { ReactNode } from 'react';
import { dayColor } from '../theme.ts';

export function ScheduleHeader({
  dayId,
  dayLabel,
  badge,
  lede,
  right,
}: {
  dayId?: string;
  dayLabel: string;
  badge?: string;
  lede?: string;
  right?: ReactNode;
}) {
  return (
    <header
      className="schedhead"
      style={dayId ? ({ ['--day' as string]: dayColor(dayId) }) : undefined}
    >
      <div className="schedhead-main">
        <h1>{dayLabel}</h1>
        {badge && <span className="roundbadge">{badge}</span>}
      </div>
      {lede && <p>{lede}</p>}
      {right && <div className="schedhead-right">{right}</div>}
    </header>
  );
}
